<template>
  <v-container class="d-flex flex-column px-10" fluid id="small-container">
    <loader :loading="loading"></loader>
    <v-layout row wrap align-left class="text-left">
      <v-flex>
        <p class="text-bold neutral--text pb-2 pt-6">{{ $t('reset-password') }}</p>
        <p class="text-light neutral--text pb-6 pt-2">{{ $t('create-password-message') }}</p>
      </v-flex>
    </v-layout>
    <v-alert
      class="error"
      id="error"
      type="info"
      dense
      icon="mdi-information-outline"
      v-if="errorSummary !== null"
      >{{ errorSummary }}</v-alert
    >
    <v-layout row wrap align-center>
      <v-flex>
        <v-form
          v-model="valid"
          class="auth-form text-left"
          ref="form"
          :lazy-validation="false"
          fluid
        >
          <label class="text-bold subtitle-2">{{ $t('new-password') }}</label>
          <v-text-field
            v-model="user.password"
            type="password"
            outlined
            placeholder="Enter Password"
            :rules="passwordRules()"
            class="pt-1 pb-1 mb-2"
          ></v-text-field>
          <label class="text-bold subtitle-2">{{ $t('confirm-password') }}</label>
          <v-text-field
            v-model="user.confirmPassword"
            type="password"
            outlined
            placeholder="Confirm Password"
            class="pt-1 pb-1 mb-2"
            :rules="confirmPasswordRules().concat(passwordConfirmationRule)"
          ></v-text-field>
        </v-form>
        <v-btn
          color="primary200"
          :disabled="!valid || loading"
          data-cy="login"
          large
          width="200"
          @click="submit"
          class="rounded-lg white--text mb-6 mt-5"
          >{{ $t('save') }}</v-btn
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus';
import Loader from '@/components/shared/helpers/Loader.vue';
import i18n from '../../i18n';
import Vue from 'vue';

export default {
  name: 'ResetPassword',
  mixins: [util],
  components: {
    Loader,
  },
  data: () => ({
    loading: false,
    valid: false,
    user: {
      password: null,
      confirmPassword: null,
    },
    responseStatus: null,
    errorSummary: null,
  }),
  methods: {
    submit() {
      this.$refs.form.validate();
      this.loading = true;
      this.axios
        .post('/api/v1/auth/reset-password?uuid=' + this.$route.query.uuid, this.user)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('password-updated'),
          });
          setTimeout(() => {
            const basePath = window.location.origin.toString();
            Vue.$keycloak.login({ redirectUri: basePath });
          }, '2000');
        })
        .catch(error => {
          if (error.request && error.response.status === 400) {
            this.errorSummary = this.$i18n.t(error.response.headers.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.user.password === this.user.confirmPassword || i18n.t('matching-password-rule');
    },
  },
};
</script>
